import { Helmet } from "react-helmet";
import Header from '../header/Header';
import HeroPlanes from './planes/HeroPlanes.js';
import Footer from '../footer/Footer';
import TablasPlanes from "./planes/TablasPlanes";
import GiftCardsPlanes from "./planes/GiftCardsPlanes";
import Accordion from '../elements/accordion/Accordion';
import { accordionDataAyuda } from './planes/AccordionDataPlanes';


function Planes() {
    
  return (
    <>
        <Helmet>
            <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
            <meta charSet="utf-8" />
            <title>Dispositivos - XDigital Neo</title>
        </Helmet>
        <Header />
        <HeroPlanes />
        <TablasPlanes 
          title="ELIGE UN PLAN A TU MEDIDA"
          copy="Opta por uno de los planes que tenemos para ti, y empieza a disfrutar de la nueva forma de vivir la TV y el Cine."
        />
        <GiftCardsPlanes />
        <Accordion accordionData={accordionDataAyuda} />
        <Footer />
    </>
  )
}

export default Planes